import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%]"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "tw-text-[#387DFF] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%]" }

import { IAttachment } from "@/interfaces/common/IAttachment";
import { PropType, onUpdated, ref } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import { assessmentAdditionalInfoType } from "@/utils/constants";
import PenIcon from "../svgs/penIcon.vue";
import Attachments from "../common/attachments.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentAdditionalInfo',
  props: {
  type: {
    type: String as PropType<assessmentAdditionalInfoType>,
    default: assessmentAdditionalInfoType.note,
  },
  attachments: {
    type: Array as PropType<Array<IAttachment>>,
    default: () => [],
  },
  text: {
    type: String as PropType<string>,
    default: "",
  },
  href: {
    type: String as PropType<string>,
    default: "#",
  },
  noteText: {
    type: String as PropType<string>,
    default: "",
  },
  checklistItemId: {
    type: Number,
    default: 0,
  },
  passkeyQuestion: {
    type: String,
    default: "",
  },
  isHovered: {
    type: Boolean,
    default: false,
  },
  maxShown: {
    type: Number,
    required: false,
    default: 3,
  },
  classNameAttachment: {
    type: String,
    default: "",
  },
  isVendorRequest: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "",
  },
  previousAnsweredId: {
    type: String,
    default: "",
  },
  attachmentId: {
    type: String,
    default: "",
  },
  isHoverShowNote: {
    type: Boolean,
    default: true,
  },
},
  emits: ["viewAttachments", "viewInfo"],
  setup(__props, { emit }) {

const props = __props;



const attachmentsRef = ref(props.attachments);

onUpdated(() => {
  attachmentsRef.value = props.attachments;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: __props.id }, [
    (_unref(assessmentAdditionalInfoType).note === __props.type)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createTextVNode(" Previously answered: "),
          _createElementVNode("span", {
            id: __props.previousAnsweredId,
            class: "tw-text-[#878787] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[145%]"
          }, _toDisplayString(__props.text), 9, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (
        __props.type === _unref(assessmentAdditionalInfoType).notes &&
        props.noteText &&
        __props.isHoverShowNote
      )
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: "tw-flex tw-items-center tw-gap-[4px] tw-w-[fit-content] tw-cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('viewInfo')))
        }, [
          _createVNode(PenIcon, {
            size: 14,
            class: "tw-w-[14px] tw-h-[11px]"
          }),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
            "app-component-assessments-additional-info-view-notes-1",
          )), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(assessmentAdditionalInfoType).attachment === __props.type)
      ? (_openBlock(), _createBlock(Attachments, {
          key: 2,
          id: __props.attachmentId,
          attachments: attachmentsRef.value,
          href: __props.href,
          "max-shown": __props.maxShown,
          "checklist-item-id": __props.checklistItemId,
          "passkey-question": __props.passkeyQuestion,
          "is-hovered": __props.isHovered,
          "class-name-attachment": __props.classNameAttachment,
          "is-vendor-request": __props.isVendorRequest,
          onViewAttachments: _cache[1] || (_cache[1] = ($event: any) => (emit('viewAttachments')))
        }, null, 8, ["id", "attachments", "href", "max-shown", "checklist-item-id", "passkey-question", "is-hovered", "class-name-attachment", "is-vendor-request"]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}
}

})